/**
 * Shared main-column content area for layouts with a left sidebar.
 * Minor side gutters only — enough to separate nav from content.
 */
export const shellContentAreaSx = {
  flex: 1,
  px: { xs: 1.5, sm: 1 },
  py: { xs: 1.5, sm: 2 },
  overflowY: 'auto',
  // Pages often wrap in <Container maxWidth="md|lg"> which leaves large side gaps
  // inside the shell. Stretch those containers to the main column (marketing
  // routes outside AppShell/AdminLayout are unaffected).
  '& .MuiContainer-root': {
    maxWidth: '100% !important',
    px: { xs: 0, sm: 0 },
  },
};
